@if (categories?.length > 0) {
  <sd-faq
    [categories]="categories"
    [hasForm]="false"
    [titleLevelCategory]="titleLevelCategory"
    (categoryOpened)="onCategoryOpened($event)"
    [brand]="brandCorner"
  />
}
